// @ts-nocheck
import React, { useState, useEffect } from 'react';
import ManageJobSchedule from '@/components/job-schedule/manage';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import { useRouter } from 'next/router';
import { createFileRoute } from '@tanstack/react-router'

function CreateJobSchedule() {

  const router = useRouter();
  const { module, moduleID, customerID } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  return (
    <div className="manage-container">
      <ManageJobSchedule isNew={true} module={module} moduleID={moduleID} customerID={customerID} />
    </div>
  );
}

export default CreateJobSchedule;

export const Route = createFileRoute('/_authenticated/job-schedule/create')({ component: CreateJobSchedule })
